<div class="loader-wrapper">
    <div class="la-square-jelly-box m-0 mb-4">
        <div>
        </div>
        <div></div>
    </div>
    <span class="text-white">Loading...</span>
</div>